import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { InvoiceTracking } from "./Table";
import { Dialog } from "primereact/dialog";
import { Fetch } from "../../shared/Fetch";
import { format } from "date-fns";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

interface IProps {
    open: boolean;
    onClose: () => void;
    toast: any;
    singleDate: InvoiceTracking;
}

interface IFollowUpEmailHistory {
    id?: number
    sendBy?: string
    sendOn?: Date
    email_Subject?: string
    email_Body?: string
    invoice_ID?: number
}

export const FollowUpEmailHistory = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IFollowUpEmailHistory[], loading: boolean });
    const [selectedRow, setSelectedRow] = useState({ singleData: {}, open: false } as { singleData: IFollowUpEmailHistory, open: boolean });

    const onHide = () => {
        props.onClose();
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/followUpHistory", "GET", null, `invoice_ID=${props.singleDate.invoice_ID}&type=email`, props.toast);
        if (response) {
            const data: IFollowUpEmailHistory[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const sendOnDate = (rowData: any) => {
        let date;
        if (rowData.sendOn) date = format(new Date(rowData.sendOn), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    useEffect(() => {
        if (props.open && props.singleDate.invoice_ID) {
            loadTableData();
        }
    }, [props.open]);

    return (
        <>
            <Dialog style={{ width: '70vw' }} visible={props.open} onHide={() => onHide()} header="Payment Follow Up Email History" >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    value={tableData.tableData}
                    loading={tableData.loading}
                    dataKey="id"
                    paginator
                    rows={100}
                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                >
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="sendBy" header="Follow Done By" />
                    <Column field="sendOn" header="Email Send On" body={sendOnDate} />
                    <Column field="email_Subject" header="Email Subject" />
                    <Column field="email_Body" header="Email Body" body={(rowData) => <p className="cursor-pointer underline text-primary" style={{ maxWidth: "12rem", textOverflow: "ellipsis" }} onClick={() => setSelectedRow({ singleData: rowData, open: true })}>Email Body</p>} />
                </DataTable>
            </Dialog>
            <Dialog style={{ width: '70vw' }} visible={selectedRow.open} onHide={() => setSelectedRow({ singleData: { email_Body: "" }, open: false })} header="Email Body" >
                <CKEditor editor={ClassicEditor} data={selectedRow.singleData?.email_Body} />
            </Dialog>
        </>
    );
}